// @flow

import type {GraphData, Language, Paging, PortfolioNotificationEvent, TabDataFlags} from '../../types'
import debounce from 'lodash.debounce'
import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import Pagination from '@/controls/pagination'
import {appSelectors, portfoliosActions, portfoliosSelectors, uiActions} from '@/store'

import EventsList from './events-list'
import EventsGraph from '@/views/events-graph'
import Overflow from '@/elements/overflow'
import Section from '@/elements/section'
import {isAnyTabDataLoaded, isHavingPortfolioId} from '@/views/util'

type Props = {
  notificationEvents: Array<PortfolioNotificationEvent>,
  filteredNotificationEvents?: Array<PortfolioNotificationEvent>,
  eventsCount: number,
  eventsPaging: Paging,
  fetchPortfolioEvents: (Object) => void,
  graphData: Array<GraphData>,
  graphStartDate: any,
  graphEndDate: any,
  setEventsPageNumber: (number) => void,
  l: Language,
  langCode: string,
  tabDataFlags: TabDataFlags,
  fetchHomeTabInitialData: () => void,
  fetchCommonTabsData: () => void,
  updateGraph: () => void,
  isLoading: boolean,
  countryCode: string,
}

const pageChange = (props) => (pageNumber) => {
  props.setEventsPageNumber(pageNumber - 1)
  props.fetchPortfolioEvents({
    startDate: props.graphStartDate,
    endDate: props.graphEndDate,
    language: props.langCode,
  })
}

const checkAndFetchData = (props) => {
  // call apis to fetch this tab data
  if (isHavingPortfolioId(props) && !props.tabDataFlags.isHomeDataLoaded && !props.isLoading) {
    // fetch common tab data if no tab is loaded yet

    if (!isAnyTabDataLoaded(props.tabDataFlags)) {
      props.fetchCommonTabsData()
    }
    // fetch graph data if analysis tab is not loaded yet
    if (!props.tabDataFlags['isAnalysisDataLoaded']) {
      props.updateGraph()
    }
    // fetch this tab data
    props.fetchHomeTabInitialData()
  }
}

export class RawHomePage extends Component<Props> {
  render = () => {
    const {props} = this
    let eventsListHeight = 0
    if (props.notificationEvents && props.notificationEvents.length > 6) {
      eventsListHeight = 300
    }
    return (
      <div>
        <Section header={props.l('Events summary')}>
          <EventsGraph notifications={props.notificationEvents}/>
        </Section>
        <Section header={props.l('Recent events')} className='events-list'>
          <Overflow height={eventsListHeight}>
            <EventsList notifications={(props.filteredNotificationEvents)
              ? props.filteredNotificationEvents : props.notificationEvents}
            l={props.l} langCode={props.langCode}
            countryCode={props.countryCode}/>
          </Overflow>
        </Section>
        { props.eventsCount > props.eventsPaging.pageSize
          ? (<Pagination
            activePage={props.eventsPaging.pageNumber + 1}
            pageSize={props.eventsPaging.pageSize}
            totalItems={props.eventsCount}
            onChange={pageChange(props)}
          />)
          : false }
      </div>
    )
  }
  componentDidMount = () => {
    checkAndFetchData(this.props)
  }

  componentWillReceiveProps = (nextProps: Props) => {
    checkAndFetchData(nextProps)
  }
}

const mapStateToProps = (state) => ({
  notificationEvents: portfoliosSelectors.getActivePortfolioNotificationEvents(state),
  filteredNotificationEvents: portfoliosSelectors.getFilteredPortfolioNotificationEvents(state),
  eventsCount: portfoliosSelectors.getActivePortfolioNotificationEventsCount(state),
  eventsPaging: state.ui.eventsPaging,
  graphData: portfoliosSelectors.getActivePortfolioGraphData(state),
  graphStartDate: state.ui.graphStartDate,
  graphEndDate: state.ui.graphEndDate,
  l: appSelectors.getL(state),
  langCode: state.app.user.preferredLanguageCode,
  tabDataFlags: state.app.tabDataFlags,
  activePortfolioId: state.app.activePortfolioId,
  isLoading: state.app.showAppLoader,
  countryCode: state.app.user.countryCode,
})

const mapDispatchToProps = (dispatch, props) => ({
  ...bindActionCreators(portfoliosActions, dispatch),
  ...bindActionCreators(uiActions, dispatch),
  fetchPortfolioEvents: debounce(
    ({startDate, endDate, language} = {}) => dispatch(portfoliosActions.fetchPortfolioEvents({startDate, endDate, language})),
    200,
  ),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RawHomePage)



// WEBPACK FOOTER //
// ./src/views/home-page/index.js